import styled from "styled-components";
import { DatePicker, Button, Select, Upload, Radio } from "antd";

export const XCalendar = styled(DatePicker)`
  width: 100%;
  height: 40px;
  margin-top: 20px;
  input {
    pointer-events: none;
  }
`;
export const XSubmit = styled(Button)`
  position: absolute;
  right: 10px;
  border-radius: 7px !important;
`;
export const SelectBox = styled(Select)`
  font-size: 14px;
  div.ant-select-selector {
    border-radius: 7px !important;
  }
`;
export const UploadBox = styled(Upload)`
  /* font-size:14px;
    div.ant-select-selector{
        border-radius:7px !important;
    } */
  .ant-upload-picture-card-wrapper {
    width: 100%;
  }
  .ant-upload.ant-upload-select-picture-card {
    width: 100%;
    height: 204px;
  }
`;
export const RadioButton = styled(Radio.Button)`
  width: 230px;
  margin-right: 1%;
  margin-bottom: 1%;
  border-radius: 7px;
  border-left-width: 1.02px;
  font-weight: 400;
  border: 1px solid #f0f0f0;
  text-align: center;
  height: 40px;
  :not(:first-child)::before {
    height: 0px;
    top: 4px;
  }
`;
